import { Form } from '@remix-run/react';
import { Button, type ButtonProps } from '~/components/button';
import { IconApple } from '~/components/icon-apple';
import { IconGoogle } from '~/components/icon-google';
import { VStack } from '~/components/stack';
import { cn } from '~/utils/cn';
import { ROUTES } from '~/utils/routes';

export function SocialSignIn() {
  return (
    <VStack className="gap-2">
      <Form action={ROUTES.AUTH.OAUTH({ provider: 'google' })} method="POST">
        <SocialButton
          data-testid="auth-button-google"
          iconStart={<IconGoogle />}
        >
          Continue with Google
        </SocialButton>
      </Form>
      <Form action={ROUTES.AUTH.OAUTH({ provider: 'apple' })} method="POST">
        <SocialButton data-testid="auth-button-apple" iconStart={<IconApple />}>
          Continue with Apple
        </SocialButton>
      </Form>
    </VStack>
  );
}

function SocialButton({ className, ...restProps }: ButtonProps) {
  return (
    <Button
      type="submit"
      className={cn(
        'w-full bg-white text-black hover:bg-slate-50 border shadow-sm',
      )}
      size="lg"
      {...restProps}
    />
  );
}
